const {validateText, words} = require('./textQuality');
const CATALOG = {
    delay: [
        ['forgot', 'Зазевался — не отправил отчёт вовремя', 'Что произошло и как будете контролировать своевременную отправку?'],
        ['missing_data', 'Не собрал данные для отчёта вовремя', 'Каких данных не хватало, у кого и когда их запросили?'],
        ['correction', 'Исправляю ранее поданный отчёт', 'Какой отчёт исправляете и какую ошибку допустили?'],
        ['connection', 'Не было связи или интернета', 'Где и в какой период отсутствовала связь? Когда появилась возможность отправить?'],
        ['technical', 'Не смог отправить из-за технической проблемы', 'Что именно не работало: устройство, вход, загрузка или настройки объекта? Что сделали для решения?'],
        ['absent', 'Не обеспечил подачу отчёта на время своего отсутствия', 'Почему отсутствовали и кому передавали подачу отчётности?'],
        ['other', 'Другая причина', 'Что конкретно помешало своевременной отправке?']
    ],
    photo: [
        ['not_organized', 'Не организовал получение фото от бригады', 'Почему не фотографировали лично? Кому поручили съёмку, почему фото не получили и что предприняли?'],
        ['forgot', 'Не сделал фотографии во время смены', 'Почему съёмку пропустили? Можно ли ещё зафиксировать результат работ?'],
        ['forbidden', 'Фотофиксация запрещена', 'Кто установил запрет и на что он распространяется?'],
        ['no_work', 'Работы в эту смену не выполнялись', 'Что происходило: дорога, простой, отсутствие допуска или другая ситуация?'],
        ['upload_failed', 'Фото есть, но пока не смог их загрузить', 'Что мешает загрузке и когда сможете приложить фотографии?'],
        ['another_report', 'Фото уже приложены к другому отчёту', 'Укажите номер отчёта и объясните, почему фотографии относятся к этой смене.'],
        ['other', 'Другая причина', 'Почему нет фотографий и что сделано для их получения?']
    ]
};
function choices(kind) { return (CATALOG[kind] || []).map(([key, label, help]) => ({key, label, help})); }
function choice(kind, key) { return choices(kind).find(item => item.key === key); }
function validateExplanation(kind, key, detail) {
    const selected = choice(kind, key);
    if (!selected) return {code: 'reason_required', message: 'Выберите причину из списка.', help: 'Затем добавьте собственное уточнение.'};
    const issue = validateText(detail, 'explanation', {help: selected.help});
    if (issue && issue.code === 'symbols_only') return Object.assign({}, issue, {
        message: 'Точки, тире и другие символы не объясняют причину. Опишите, что произошло'
    });
    if (issue) return issue;
    if (words(detail) === words(selected.label)) return {code: 'reason_repeated', message: 'Уточнение повторяет выбранную причину.', help: selected.help};
    return null;
}
function formatExplanation(kind, key, detail) {
    const selected = choice(kind, key);
    return selected ? `${selected.label}\n\n${detail.trim()}` : detail;
}
// Existing rule: three complete days since shift start. Business time is UTC+03:00 in both tenants.
function shiftStart(startDate, startTime) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(startDate || '') || !/^\d{2}:\d{2}$/.test(startTime || '')) return NaN;
    const start = Date.parse(`${startDate}T${startTime}:00+03:00`);
    if (!Number.isFinite(start) || new Date(start + 3 * 3600000).toISOString().slice(0, 16) !== `${startDate}T${startTime}`) return NaN;
    return start;
}
function delayRequired(startDate, startTime, now) {
    const start = shiftStart(startDate, startTime);
    return Number.isFinite(start) && (now === undefined ? Date.now() : Number(now)) - start >= 3 * 86400000;
}
function organizational(kind, key) {
    return (kind === 'delay' ? ['forgot', 'missing_data', 'absent'] : kind === 'photo' ? ['not_organized', 'forgot'] : []).includes(key);
}
module.exports = {organizational, choices, choice, validateExplanation, formatExplanation, delayRequired, shiftStart};
